import { getPluralForm } from './getPluralForm';

export const getDeviceStatusText = (eventDate, showStatus = true) => {
  const lastEventDate = new Date(eventDate);
  if (!eventDate || isNaN(lastEventDate)) return showStatus ? 'Устройство не выходило на связь' : '';

  const hoursAgo = Math.round((Date.now() - lastEventDate) / 3600000);
  let statusText = '';

  if (hoursAgo < 24) {
    statusText = hoursAgo === 0 ? 'менее часа назад' : `${hoursAgo} ${getPluralForm(hoursAgo, ['час', 'часа', 'часов'])} назад`;
  } else {
    const daysAgo = Math.round(hoursAgo / 24);
    if (daysAgo <= 30) {
      statusText = `${daysAgo} ${getPluralForm(daysAgo, ['день', 'дня', 'дней'])} назад`;
    } else {
      const monthsAgo = Math.round(daysAgo / 30);
      if (monthsAgo < 12) {
        statusText = `${monthsAgo} ${getPluralForm(monthsAgo, ['месяц', 'месяца', 'месяцев'])} назад`;
      } else {
        const yearsAgo = Math.round(monthsAgo / 12);
        statusText = `более ${yearsAgo} ${getPluralForm(yearsAgo, ['года', 'лет', 'лет'])} назад`;
      }
    }
  }

  return showStatus ? `Был в сети: ${statusText}` : statusText;
};
